export const HeightScaleDirections = {
  Up: "up",
  Down: "down"
} as const;
export type HeightScaleDirections = (typeof HeightScaleDirections)[keyof typeof HeightScaleDirections];
